import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useNavigate } from 'react-router-dom';



const Intro = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className='videowrap'>
        <Swiper
          spaceBetween={30}
          effect={'fade'}
          navigation={false}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 14000,
            disableOnInteraction: true,
          }} loop={true} speed={2000}
          modules={[EffectFade, Navigation, Pagination, Autoplay]}
          className="vdslide"
        >
          <SwiperSlide>
            <button className='btn' onClick={() => { navigate('/main') }}><img src="img/logo3.png" alt="" /></button>
            {/* <p className='btnp'>더 많은 제품 보기</p> */}
            <video className='vd1' autoPlay muted loop width={"100%"} height={"100%"} src="https://www.tamburins.com/img/renew_dummy/category/[220123]main_web_1920x710.mp4" />

          </SwiperSlide>
        </Swiper>
      </div>

    </>
  )
}

export default Intro